import { commitMutation, graphql } from 'react-relay';
import environment from '../../environment';

const mutation = graphql`
  mutation confirmationEmailMutation($input: confirmationEmailMutationInput!) {
    sendConfirmationEmail(input: $input) {
      code
      message
    }
  }
`;

function sendConfirmationEmail(data, callback) {
  const variables = {
    input: {
      emailInput: data,
    },
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      callback(response);
    },
    onError: err => console.error(err),
  });
}

export default sendConfirmationEmail;
